import { connectivityFactory } from "../shared/connectivityFactory";

export const connectivity = connectivityFactory(document);